import { SignupLoginService } from 'src/app/services/signupLogin.service';
import { map, takeUntil } from 'rxjs/operators';
import { Component, OnInit, ViewChild } from '@angular/core';
import { GeneralTaskService } from 'src/app/services/task/general-task.service';
import { GeneralService } from 'src/app/services/general.service';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import * as $ from 'jquery';
import { Subject, BehaviorSubject, of, Observable, forkJoin } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.state';
import { noWhitespaceValidator } from 'src/app/utils/no-whitespace.validator';
import { DataTableTypes } from "inn-datatable";
import { selectConfig } from 'src/app/utils/utils';
import { mergeMap } from 'rxjs/operators';
import { ClientService } from 'src/app/services/client-services/clients.service';
import { EmailClientService } from 'src/app/services/integrations/email/email-client.service';
import { DealsService } from 'src/app/services/deals.service';
import { EditFilterTaskComponent } from '../edit-filter-task/edit-filter-task.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-all-my-tasks',
  templateUrl: './all-my-tasks.component.html',
  styleUrls: ['./all-my-tasks.component.css']
})

export class AllMyTasksComponent implements OnInit {

  @ViewChild(EditFilterTaskComponent) Filter: EditFilterTaskComponent;
  private unsubscribe = new Subject();
  createdTask;
  allGeneralTasks: any = [];
  userID: any;
  user: any;
  supervisorAttachedUsers: any = [];
  selectedClientID: string = '';
  myCreatedTasks: any = [];
  remindDate: Date;
  task: any = {};
  dataClient;
  clients: any = [];
  clientList: any = [];
  clientFilterString: any = [];
  suggestedDeals: any = [];
  suggestedDeals2: any = [];
  filterDealCode: string = '';
  inputText: string;
  inputText2: string;
  personalFilter="";
  userFilter: any;
  taskID: string;
  restricDateTYP = new Date();
  createLoading: boolean = false;
  isLoading: boolean = false;
  commentLoading: boolean = false;
  isLoadingDeals: boolean = false;
  myTaskFilter: string = '';
  showFilter = null;
  fullList = "col-xl-12 col-lg-12 col-md-12";
  halfList = "col-xl-10 col-lg-9 col-md-8";
  sidebarState = "open";
  mainStyle = this.halfList;
  clientListFilter;
  editClient;
  clientListFilter2;
  dealList$: Observable<any>;
  filterList$: Observable<any[]>;
  salesperson_config = {
    search: true, // true/false for the search functionlity defaults to false,
    placeholder: "Select Salesperson", // text to be displayed when no item is selected defaults to Select,
    limitTo: 10, // a number thats limits the no of options displayed in the UI similar to angular's limitTo pipe
    noResultsFound: "No results found!", // text to be displayed when no items are found while searching
    searchPlaceholder: "search salesperson",
    displayKey: 'fullName',
  };
  Clientconfig = { ...selectConfig, placeholder: 'Search Client', noResultsFound: "Type here to search" };
  Dealconfig = { ...selectConfig, placeholder: 'Search Deal', noResultsFound: "Client Has No Deal" };
  usersList: any[];
  orgId;
  assignArray: any[];
  comment: string;
  type: any;
  columnData;

  loader: any = {
    default: "notch-loader",
    spinnerType: "",
    spinnerStyle: {},
    dataless: {
      title: "No Data Available!",
      subTitle: "Please  try again",
      action: "Load Teams",
      success: true
    },
    showSpinner: false
  };

  constructor(
    store: Store<AppState>,
    private router: Router,
    private dealServ: DealsService,
    private formBuilder: FormBuilder,
    private clientSrv: ClientService,
    private generalSrv: GeneralService,
    private signupSrv: SignupLoginService,
    private generalTaskSrv: GeneralTaskService,
    private emailClientService: EmailClientService,
  ) {
    this.loader.spinnerType = this.loader.default;
    store.select("userInfo").subscribe(info => {
      this.user = info.user
      this.userID = info.user.id;
      this.orgId = info.organization.id;
    });
  }

  ngOnInit() {
    this.generalSrv.showSpinner.next(false);
    this.remindDate = new Date();
    this.generalTaskSrv.refreshNeeded$
      .subscribe(() => {
        this.FetchAssignedTasks();
        this.FetchCreatedTasks();
      })
    this.getAllFilters();
    this.getUsers()
    this.FetchAssignedTasks();
    this.FetchCreatedTasks();
    this.onFetchSupervisorAttachedUsers();
  }

  dataTable = {
    dataChangedObs: new BehaviorSubject(null),
    heads: <DataTableTypes.Head[]>[
      { title: "Due Date/Time", key: "dueDate" },
      { title: "Name", key: "name" },
      { title: "Assigned By", key: "creatorName" },
      {
        title: "Status",
        key: "status",
        html: fieldData => {
          if (fieldData === 'PENDING') {
            return `<span class='contact-detail badge-warning pl-2 pr-2 text-uppercase task-tunji'>${fieldData} </span>`;
          } else if (fieldData === 'COMPLETED') {
            return `<span class='contact-detail badge-success pl-2 pr-2 text-uppercase task-tunji'>${fieldData} </span>`;
          } else if (fieldData === 'VOIDED') {
            return `<span class='contact-detail badge-danger pl-2 pr-2 text-uppercase task-tunji'>${fieldData} </span>`;
          } else if (fieldData === 'OVERDUE' || fieldData === 'overdue' || fieldData === 'Overdue') {
            return `<span class='contact-detail badge-info pl-2 pr-2 text-uppercase task-tunji'>${fieldData} </span>`;
          }

        }
      },
      { title: "Action", key: "action" }
    ],
    options: <DataTableTypes.Options>{
      noOfRowsToDisplay: 10,
      debug: true,
      emitClickActions: ["View"],
      singleActions: [
        {
          title: "View",
          showIf: () =>
            this.generalSrv.isAuthorized("VIEW_TASKS"),
        },
        {
          title: "Edit Task", showIf: (fieldData, rowData) =>
            (rowData.status === 'PENDING' || rowData.status === 'OVERDUE' || rowData.status === 'overdue' || rowData.status === 'Overdue') && rowData.creatorID == this.userID && this.generalSrv.isAuthorized("EDIT_TASKS")
        },
        {
          title: "Mark As Completed", showIf: (fieldData, rowData) =>
            (rowData.status === 'PENDING' || rowData.status === 'OVERDUE' || rowData.status === 'overdue' || rowData.status === 'Overdue') && (rowData.creatorID == this.userID || rowData.assigneeID == this.userID) && this.generalSrv.isAuthorized("MARK_AS_COMPLETED")
        },
        {
          title: "Mark As Void", showIf: (fieldData, rowData) =>
            (rowData.status === 'PENDING' || rowData.status === 'OVERDUE' || rowData.status === 'overdue' || rowData.status === 'Overdue') && (rowData.creatorID == this.userID || rowData.assigneeID == this.userID) && this.generalSrv.isAuthorized("MARK_AS_VOID")
        }
      ]
    }
  };

  dataFeedBackObsListener = data => {
    switch (data.type) {
      case "singleaction":
        if (data.action === "View" && this.generalSrv.isAuthorized("VIEW_TASKS")) {
          // @ts-ignore
          this.router.navigate(["/view-my-tasks/" + data.data.id]);
        } else if (data.action === "Edit Task") {
          // @ts-ignore
          document.getElementById('openEditTaskModal').click();
          this.onEditTask(data.data.id)
        } else if (data.action === "Mark As Completed") {
          // @ts-ignore
          this.type = "COMPLETED"
          this.statusComment(data.data.id)
        } else if (data.action === "Mark As Void") {
          // @ts-ignore
          this.type = "VOIDED"
          this.statusComment(data.data.id)
        }
        break;

      default:

        break;
    }
  };

  dataTable2 = {
    dataChangedObs: new BehaviorSubject(null),
    heads: <DataTableTypes.Head[]>[
      { title: "Due Date/TIME", key: "dueDate" },
      { title: "Name", key: "name" },
      { title: "Assigned To", key: "assigneeName" },
      {
        title: "Status",
        key: "status",
        html: fieldData => {
          if (fieldData === 'PENDING') {
            return `<span class='contact-detail badge-warning pl-2 pr-2 text-uppercase task-tunji'>${fieldData} </span>`;
          } else if (fieldData === 'COMPLETED') {
            return `<span class='contact-detail badge-success pl-2 pr-2 text-uppercase task-tunji'>${fieldData} </span>`;
          } else if (fieldData === 'VOIDED') {
            return `<span class='contact-detail badge-danger pl-2 pr-2 text-uppercase task-tunji'>${fieldData} </span>`;
          } else if (fieldData === 'OVERDUE' || fieldData === 'overdue' || fieldData === 'Overdue') {
            return `<span class='contact-detail badge-info pl-2 pr-2 text-uppercase task-tunji'>${fieldData} </span>`;
          }

        }
      },
      { title: "Action", key: "action" }
    ],
    options: <DataTableTypes.Options>{
      noOfRowsToDisplay: 10,
      debug: true,
      emitClickActions: ["View"],
      singleActions: [
        {
          title: "View",
          showIf: () =>
            this.generalSrv.isAuthorized("VIEW_TASKS"),
        },
        {
          title: "Edit Task", showIf: (fieldData, rowData) =>
            (rowData.status === 'PENDING' || rowData.status === 'OVERDUE' || rowData.status === 'overdue' || rowData.status === 'Overdue') && rowData.creatorID == this.userID && this.generalSrv.isAuthorized("EDIT_TASKS")
        },
        {
          title: "Mark As Completed", showIf: (fieldData, rowData) =>
            (rowData.status === 'PENDING' || rowData.status === 'OVERDUE' || rowData.status === 'overdue' || rowData.status === 'Overdue') && (rowData.creatorID == this.userID || rowData.assigneeID == this.userID)  && this.generalSrv.isAuthorized("MARK_AS_COMPLETED")
        },
        {
          title: "Mark As Void", showIf: (fieldData, rowData) =>
            (rowData.status === 'PENDING' || rowData.status === 'OVERDUE' || rowData.status === 'overdue' || rowData.status === 'Overdue') && (rowData.creatorID == this.userID || rowData.assigneeID == this.userID) && this.generalSrv.isAuthorized("MARK_AS_VOID")
        }
      ]
    }
  };

  dataFeedBackObsListener2 = data => {
    switch (data.type) {
      case "singleaction":
        if (data.action === "View" && this.generalSrv.isAuthorized("VIEW_TASKS")) {
          // @ts-ignore
          this.router.navigate(["/view-my-tasks/" + data.data.id]);
        } else if (data.action === "Edit Task") {
          // @ts-ignore
          document.getElementById('openEditTaskModal').click();
          this.onEditTask(data.data.id)
        } else if (data.action === "Mark As Completed") {
          // @ts-ignore
          this.type = "COMPLETED"
          this.statusComment(data.data.id)
        } else if (data.action === "Mark As Void") {
          // @ts-ignore
          this.type = "VOIDED"
          this.statusComment(data.data.id)
        }
        break;

      default:

        break;
    }
  };

  editTaskForm = this.formBuilder.group({
    taskName: new FormControl('', [Validators.required, noWhitespaceValidator]),
    remindDate: new FormControl(''),
    remindTime: new FormControl('', Validators.required),
    assignedUserID: new FormControl('', Validators.required),
    taskDescription: new FormControl('', Validators.required),
    client: new FormControl(''),
    deal: new FormControl(''),
    taskID: new FormControl(''),
    channel: new FormControl(''),
    clientID: new FormControl(''),
    clientName: new FormControl(''),
    creatorName: new FormControl(''),
    completedDate: new FormControl(''),
    createdDate: new FormControl(''),
    dealCode: new FormControl(''),
    dealName: new FormControl(''),
    section: new FormControl(''),
    otherName: new FormControl(''),
    otherID: new FormControl(''),
    status: new FormControl(''),
    voidedDate: new FormControl(''),
  })

  clientFilterForm = new FormGroup({
    clientInput: new FormControl(''),
  })

  userFilterForm = new FormGroup({
    selectedUserID: new FormControl(''),
  })

  dealFilterForm = new FormGroup({
    inputText: new FormControl(''),
    filterDealCode: new FormControl(''),
    filterDealName: new FormControl('')
  })

  createFilterForm = new FormGroup({
    name: new FormControl('', [Validators.required, noWhitespaceValidator]),
    typeFilter: new FormControl('', Validators.required),
    statusFilter: new FormControl(''),
    userFilter: new FormControl(''),
    clientFilter: new FormControl(''),
    dealFilter: new FormControl(''),

  })

  whatsAppForm = this.formBuilder.group({
    whatsappNumber: new FormControl('', [Validators.required, noWhitespaceValidator]),
  })

  //FETCH TASK
  /**
    * Fetch All Assigned Task by type
    * 2 = ASSIGNED TO 
    */
  FetchAssignedTasks() {
    this.loader.showSpinner = true;
    this.generalTaskSrv.getAssignTasks()
      .subscribe(allUserTasks => {
        this.initializeLoad(allUserTasks);
        this.dataTable.dataChangedObs.next(true);
      })
  }

  /**
  * Fetch All Assigned Task by type
  * 1 = CREATED BY 
  */
  FetchCreatedTasks() {
    this.loader.showSpinner = true;
    this.generalTaskSrv.getCreatedTasks()
      .subscribe(allUserTasks => {
        this.initializeLoad2(allUserTasks);
        this.dataTable2.dataChangedObs.next(true);
      })
  }

  //STATUS COMPLETION AND VOIDED
  statusComment(id) {
    document.getElementById('addComment').click();
    this.columnData = id;
  }

  createComment() {
    if (!this.type) {
      $(`#closeComment`).click();
      this.generalSrv.sweetAlertError("All Field's are Required")
    } else {
      const payload = {
        comment: this.comment,
        commentCategory: this.type,
        orgID: this.orgId,
        taskID: this.columnData,
        userID: this.userID
      }
      this.commentLoading = true;
      this.generalTaskSrv.commentOnTask(payload).pipe(takeUntil(this.unsubscribe)).subscribe((data: any) => {
        if (this.type == "COMPLETED") {
          this.commentLoading = false;
          $(`#closeComment`).click();
          this.onMarkTaskAsCompleted(this.columnData);
        } else {
          this.commentLoading = false;
          $(`#closeComment`).click();
          this.onMarkTaskAsVoid(this.columnData);
        }
      })
    }

  }

  /**
  * Mark Task As Complete
  * @param id
  */
  onMarkTaskAsCompleted(id) {
    this.markTaskAsCompleted(id);
  }

  /**
   * Mark Task As Complete by id
   * @param id
   */
  private markTaskAsCompleted(id) {
    const status = "COMPLETED"
    this.generalTaskSrv.markTaskStatus(id, status)
      .subscribe(() => {
        this.comment = "";
        this.type = "";
        this.generalSrv.sweetAlertSucess("Your Task Has Been Marked As Completed");
        this.FetchAssignedTasks();
        this.FetchCreatedTasks();
        document.getElementById('assign-tab').click();
      }, error => {
        this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error));
      });
  }

  /**
    * Mark Task As Complete
    * @param id
    */
  onMarkTaskAsVoid(id) {
    this.markTaskAsVoid(id);
  }

  /**
   * Mark Task As Void by id
   * @param id
   */
  private markTaskAsVoid(id) {
    const status = "VOIDED"
    this.generalTaskSrv.markTaskStatus(id, status)
      .subscribe(() => {
        this.comment = "";
        this.type = "";
        this.generalSrv.sweetAlertSucess("Your Task Has Been Voided");
        this.FetchAssignedTasks();
        this.FetchCreatedTasks();
        document.getElementById('assign-tab').click();
      }, error => {
        this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error));
      });
  }

  //FETCH TASK BY ID
  /**
    * getting data value for Task Edit
    * @param data
    */
  setFormValues(data) {
    this.dataClient = data.clientID;
    this.f.taskID.setValue(data.id);
    this.f.taskName.setValue(data.name);
    this.f.assignedUserID.setValue(data.assigneeID);
    this.f.taskDescription.setValue(data.description);
    const split0 = data.dueDate.split("");
    const date = `${split0[6]}${split0[7]}${split0[8]}${split0[9]}-${split0[3]}${split0[4]}-${split0[0]}${split0[1]}`;
    this.f.remindDate.setValue(new Date(date));
    const split = data.dueDate.split("");
    const time = `${split[11]}${split[12]}:${split[14]}${split[15]}`;
    this.f.remindTime.setValue(time);
  }

  get f() {
    return this.editTaskForm.controls;
  }

  /**
   * Fetch Task By ID
   * @param id
   */
  fetchTaskByID(id) {
    this.task = '';
    this.isLoading = true;
    this.generalTaskSrv.getTaskByID(id).subscribe(task => {
      this.task = task;
      this.isLoading = false;
      this.setFormValues(task);
    })
  }

  //ON SUBMISSION
  /**
     * Edit Task By id
     * @param id
     */
  onEditTask(id) {
    this.editTaskForm.reset();
    this.fetchTaskByID(id);
    this.taskID = id;
  }

  /**
  * Edit Task
  */
  private editGeneralTask() {
    this.isLoading = true;
    this.generalTaskSrv.editGeneralTaskByID(this.editTaskForm.getRawValue()).subscribe(data => {
      this.isLoading = false;
      $("#closeEditTaskModal").click();
      this.generalSrv.sweetAlertSucess("Your Task Has Been Updated SuccessFully");
      this.FetchAssignedTasks();
      this.FetchCreatedTasks();
      this.editTaskForm.reset();
    }, () => {
      this.isLoading = false;
      $("#closeEditTaskModal").click();
      this.generalSrv.sweetAlertError("Error Occurred While Updating Task");
    })
  }

  /**
  * Update Task
  */
  onUpdateTask(task) {
    this.editTaskForm.patchValue({
      channel: task.channel,
      clientID: task.clientID,
      clientName: task.clientName,
      creatorName: task.creatorName,
      completedDate: task.completedDate,
      createdDate: task.createdDate,
      dealCode: task.dealCode,
      dealName: task.dealName,
      taskID: task.id,
      section: task.section,
      otherID: task.otherID,
      otherName: task.otherName,
      status: task.status,
      voidedDate: task.voidedDate,
    });
    this.editGeneralTask();
  }

  //<!-- FILTER SECTION START --->
  //FILTER TASK BY STATUS, (CREATED AND ASSIGNED)
  /**
 * Filter Task Created By or Assigned to
 * @param event
 */
  public onMyTaskFilter(event) {
    this.myTaskFilter = event;
    if (this.myTaskFilter === 'completed') {
      document.getElementById('assign-tab').click();
      this.FetchCreatedStatus("COMPLETED");
      this.FetchAssignedStatus("COMPLETED");
    } else if (this.myTaskFilter === 'pending') {
      document.getElementById('assign-tab').click();
      this.FetchCreatedStatus("PENDING");
      this.FetchAssignedStatus("PENDING");
    } else if (this.myTaskFilter === 'overdue') {
      document.getElementById('assign-tab').click();
      this.FetchCreatedStatus("OVERDUE");
      this.FetchAssignedStatus("OVERDUE");
    } else if (this.myTaskFilter === 'voided') {
      document.getElementById('assign-tab').click();
      this.FetchCreatedStatus("VOIDED");
      this.FetchAssignedStatus("VOIDED");
    }
  }

  /**
   * Fetch Created Task By Status
   * @param status
   */
  private FetchCreatedStatus(status) {
    const payload = {
      status: status,
      type: 1,
      userID: [this.userID]
    }
    this.loader.showSpinner = true;
    this.generalTaskSrv.getFilteredTask(payload)
      .subscribe(allUserTasks => {
        this.initializeLoad2(allUserTasks);
        this.dataTable2.dataChangedObs.next(true);
      })
  }

  /**
   * Fetch Assigned Task By Status
   * @param status
   */
  private FetchAssignedStatus(status) {
    const payload = {
      status: status,
      type: 2,
      userID: [this.userID]
    }
    this.loader.showSpinner = true;
    this.generalTaskSrv.getFilteredTask(payload)
      .subscribe(allUserTasks => {
        this.initializeLoad(allUserTasks);
        this.dataTable.dataChangedObs.next(true);
      })
  }

  //FILTER TASK BY USER (CREATED AND ASSIGNED)
  /**
   * filter by user using creatorID and AssignedID
   * @param userID
   */
  filterAssignedByUser(userID) {
    const payload = {
      status: "",
      type: 2,
      userID: [userID]
    }
    this.loader.showSpinner = true;
    this.generalTaskSrv.getFilteredTask(payload)
      .subscribe(allUserTasks => {
        this.initializeLoad(allUserTasks);
        this.dataTable.dataChangedObs.next(true);
      })
  }

  /**
   * filter created task by user
   * @param userID
   */
  filterCreatedByUser(userID) {
    const payload = {
      status: "",
      type: 1,
      userID: [userID]
    }
    this.loader.showSpinner = true;
    this.generalTaskSrv.getFilteredTask(payload)
      .subscribe(allUserTasks => {
        this.initializeLoad2(allUserTasks);
        this.dataTable2.dataChangedObs.next(true);
      })
  }

  /**
   * USER FILTERS
   * @param event
   */
  public onUserFilter(event) {
    const seleted = event.id;
    document.getElementById('assign-tab').click();
    this.filterAssignedByUser(seleted);
    this.filterCreatedByUser(seleted);
  }

  //FILTER TASK BY CLIENT (CREATED AND ASSIGNED)
  /**
   *Get Assigned Filter By CLIENTID
    * @param clientID
    */
  getAssignedFilteredClient(clientID) {
    const payload = {
      clientID: [clientID],
      status: "",
      type: 2,
      userID: [this.userID]
    }
    this.loader.showSpinner = true;
    this.generalTaskSrv.getFilteredTask(payload)
      .subscribe(allUserTasks => {
        this.initializeLoad(allUserTasks);
        this.dataTable.dataChangedObs.next(true);
      })
  }

  /**
  * Get Created Filter By CLIENTID
  * @param clientID
  */
  getCreatedFilteredClient(clientID) {
    const payload = {
      clientID: [clientID],
      status: "",
      type: 1,
      userID: [this.userID]
    }
    this.loader.showSpinner = true;
    this.generalTaskSrv.getFilteredTask(payload)
      .subscribe(allUserTasks => {
        this.initializeLoad2(allUserTasks);
        this.dataTable2.dataChangedObs.next(true);
      })
  }

  /**
   * Filter Client
   */
  addClient(event) {
    this.selectedClientID = event.id
    document.getElementById('assign-tab').click();
    this.getAssignedFilteredClient(this.selectedClientID);
    this.getCreatedFilteredClient(this.selectedClientID);
  }

  /**
   * Client Suggestion
   * @param value
   */
  clientLookUp(value) {
    if (value.length <= 0 || value == undefined || !value) {
      this.clearSuggestedUsers();
      return;
    }
    this.Clientconfig.noResultsFound = 'No results found!'
    const leads_lookup = this.emailClientService.fetchClientsByWildcard(value, "leads");
    const client_lookup = this.clientSrv.getClientWildcard(value);
    forkJoin([leads_lookup, client_lookup]).subscribe(
      (responses: any) => {
        let lookUp = [];

        if (responses[0].success) {
          lookUp = [...lookUp, ...responses[0].payload]
        }

        if (responses[1]) {
          lookUp = [...lookUp, ...responses[1].payload]
        }

        this.clientListFilter = [...lookUp];
        this.editClient = [...lookUp];
      })

  }

  /**
  * Client Suggestion
  * @param value
  */
  clientLookUpEdit(value) {
    const inputText = value.trim()
    if (!inputText) {
      this.clearSuggestedUsers();
      return;
    }
    this.Clientconfig.noResultsFound = 'No results found!'
    const leads_lookup = this.emailClientService.fetchClientsByWildcard(value, "leads");
    const contacts_lookup = this.emailClientService.fetchClientsByWildcard(value, "contacts");
    const companies_lookup = this.emailClientService.fetchClientsByWildcard(value, "companies");
    forkJoin([leads_lookup, contacts_lookup, companies_lookup]).subscribe(
      (responses: any) => {
        let lookUp = [];

        if (responses[0].success) {
          lookUp = [...lookUp, ...responses[0].payload]
        }

        if (responses[1]) {
          lookUp = [...lookUp, ...responses[1].payload]
        }

        if (responses[2]) {
          lookUp = [...lookUp, ...responses[2].payload]
        }

        this.editClient = inputText.trim() ? [...lookUp] : [];
      })
  }

  getClientDealsEdit() {
    this.editTaskForm.patchValue({ deal: '' });
    const clientInfo = this.editTaskForm.value.client;
    if (this.editTaskForm.value.client = !undefined) {
      this.dealList$ = this.dealServ.getAllContactDeals("client", clientInfo.id)
    }
  }

  clearSuggestedUsers() {
    this.clientListFilter = [];
    this.clientListFilter2 = [];
    this.editClient = [];
  }

  updateNoResultText() {
    const el = document.querySelector('.ngx-dropdown-container .ngx-dropdown-list-container ul li:last-child')
    el.textContent = 'No results found!'
  }

  //FILTER TASK BY DEAL (CREATED AND ASSIGNED)
  /**
   * Get deal Filter By USERID AND dealCode
   * @param userID
   * @param dealCode
   */
  getAssignedFilteredDeal(dealCode) {
    const payload = {
      dealCode: [dealCode],
      status: "",
      type: 2,
      userID: [this.userID]
    }
    this.loader.showSpinner = true;
    this.generalTaskSrv.getFilteredTask(payload)
      .subscribe(allUserTasks => {
        this.initializeLoad(allUserTasks);
        this.dataTable.dataChangedObs.next(true);
      })
  }

  /**
  * Get deal Filter By  dealCode
  * @param dealCode
  */
  getCreatedFilteredDeal(dealCode) {
    const payload = {
      dealCode: [dealCode],
      status: "",
      type: 1,
      userID: [this.userID]
    }
    this.loader.showSpinner = true;
    this.generalTaskSrv.getFilteredTask(payload)
      .subscribe(allUserTasks => {
        this.initializeLoad2(allUserTasks);
        this.dataTable2.dataChangedObs.next(true);
      })
  }

  /**
   * Filter Deal
   * @param value
   * @param inputName
   */
  addDealFilter(value) {
    this.dealFilterForm.patchValue({ inputText: value.name });
    this.dealFilterForm.patchValue({ filterDealCode: value.code });
    this.filterDealCode = value.code;
    document.getElementById('assign-tab').click();
    this.getAssignedFilteredDeal(this.filterDealCode);
    this.getCreatedFilteredDeal(this.filterDealCode);
    this.clearSuggestedDeals();
  }

  /**
   * Get Deals Suggestion for deals filter
   */
  onGetDealSuggestions() {
    if (this.dealFilterForm.getRawValue().length <= 0 || this.dealFilterForm.getRawValue() == undefined || !this.dealFilterForm.getRawValue()) {
      this.clearSuggestedUsers();
      return;
    }
    this.isLoadingDeals = true;
    this.generalTaskSrv.getDealSuggestions(this.dealFilterForm.getRawValue()).subscribe((suggestedDeals2) => {
      this.isLoadingDeals = false;
      this.suggestedDeals2 = suggestedDeals2;
    })
  }

  /**
  * clear deals suggestions
  */
  clearSuggestedDeals() {
    this.suggestedDeals = [];
    this.suggestedDeals2 = [];
  }

  /**
  * Clear Filter Details
  */
  onClearFilters() {
    this.FetchAssignedTasks();
    this.FetchCreatedTasks();
    this.selectedClientID = "";
    this.inputText = "";
    this.inputText2 = "";
    this.personalFilter = "";
    this.userFilter = "";
    this.clientListFilter = []
    this.userFilterForm.controls['selectedUserID'].patchValue([]);
    this.clientFilterForm.controls['clientInput'].patchValue([]);
    this.dealFilterForm.controls['filterDealName'].patchValue([]);
    this.dealFilterForm.controls['filterDealCode'].patchValue([]);
    document.getElementById('assign-tab').click();
  }

  //CREATE FILTER
  clientLookUp2(value) {
    if (value.length <= 0 || value == undefined || !value) {
      this.clearSuggestedUsers();
      return;
    }
    this.Clientconfig.noResultsFound = 'No results found!'
    const leads_lookup = this.emailClientService.fetchClientsByWildcard(value, "leads");
    const client_lookup = this.clientSrv.getClientWildcard(value);
    forkJoin([leads_lookup, client_lookup]).subscribe(
      (responses: any) => {
        let lookUp = [];

        if (responses[0].success) {
          lookUp = [...lookUp, ...responses[0].payload]
        }

        if (responses[1]) {
          lookUp = [...lookUp, ...responses[1].payload]
        }

        this.clientListFilter2 = [...lookUp];
      })

  }

  getClientDeals() {
    this.createFilterForm.patchValue({ dealFilter: '' });
    const clientInfo = this.createFilterForm.value.clientFilter;
    if (this.createFilterForm.value.clientFilter = !undefined) {
      this.dealList$ = this.dealServ.getAllContactDeals("client", clientInfo.id)
    }
  }

  /**
   * Create Filter
   */
  createFilter() {
    this.createLoading = true;
    this.generalTaskSrv.createTaskFilter(this.createFilterForm.getRawValue()).subscribe(
      (result: any) => {
        this.createLoading = false;
        this.generalSrv.sweetAlertSucess(result.message);
        this.createFilterForm.reset();
        this.createFilterForm.controls['userFilter'].patchValue([]);
        this.createFilterForm.controls['dealFilter'].patchValue([]);
        this.createFilterForm.controls['clientFilter'].patchValue([]);
        this.getAllFilters();
        document.getElementById('create').click();
        this.clientListFilter2 = []
      },
      error => {
        this.createLoading = false;
        this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error));
      }
    )
  }

  /**
   * Getting All FILTERS for teams
   */
  getUsers() {
    this.signupSrv.getUsersInOrganization(this.orgId).subscribe((res: any) => {
      this.usersList = res;
      this.getAllFilters();
    })
  }

  /**
   * Get All uUser Filter
   */
  getAllFilters() {
    this.generalTaskSrv.getAllTaskFilter().pipe(mergeMap((filter: any[]) => {
      let result = [];
      if(filter && filter.length > 0){
      result = filter.map(fit => {
        if(this.usersList && this.usersList.length > 0){
          const user = this.usersList.find(user => user.user.id == fit.userID[0]);
          const clients = fit.clients && fit.clients[0] ? fit.clients[0] : {}
          const deals = fit.deals && fit.deals[0] ? fit.deals[0] : {}
          return { ...fit, clients, deals, userName: user ? (`${user.user.firstName} ${user.user.lastName}`) : null }     
        }else{
          return {...fit}
        }
      })
      }
      return of(result);
    })).subscribe((data: any) => {
      this.filterList$ = data;
    });
  }

  getAssignedCustomFilter(id) {
    this.loader.showSpinner = true;
    this.generalTaskSrv.getCustomFilterTask(id)
      .subscribe((data: any[]) => {
        this.initializeLoad(data);
        document.getElementById('assign-tab').click();
      })
  }

  getCreatedCustomFilter(id) {
    this.loader.showSpinner = true;
    this.generalTaskSrv.getCustomFilterTask(id).subscribe((allUserTasks) => {
      this.initializeLoad2(allUserTasks);
      this.dataTable2.dataChangedObs.next(true);
    })
  }

  customFilter(value) {
    const elementId = value.type == 1 ? 'created-tab' : 'assign-tab';
    document.getElementById(elementId).click();
    if (value.type) {
      this.getAssignedCustomFilter(value.id);
    }
  }

  /**
   * To View The Filter
   * @param index
   */
  activateEdit(index) {
    document.getElementById(`collapseHead-${index}`).click();
  }

  /**
   * Edit Filter
   * @param index
   */
  editFilter(index) {
    this.showFilter = index;
  }

  /**
 * Edit Filter
 * @param data
 */
  getEditFilter(data) {
    this.Filter.editLoading = true;
    this.generalTaskSrv.editFilter(data).subscribe(
      (res: any) => {
        this.cancelFiter(0);
        this.Filter.editLoading = false;
        this.getAllFilters();
        this.generalSrv.sweetAlertSucess(res.message);
      },
      error => {
        this.Filter.editLoading = false;
        this.getAllFilters();
        this.generalSrv.sweetAlertError(this.generalSrv.getErrMsg(error));
      }
    );
  }

  /**
   * Cancel Filter
   * @param index
   */
  cancelFiter(index) {
    this.showFilter = !index;
  }

  /**
   * Delete Filter
   * @param filter
   */
  deleteFilter(filter) {
    this.generalSrv.sweetAlertFileDeletions(filter.name).then(result => {
      if (result.value) {
        this.deleteFilterTask(filter);
      }
    });
  }

  /**
  *Delete Filtered Task By Id
  * @param filter
  */
  deleteFilterTask(filter) {
    this.generalTaskSrv
      .deleteFilterTask(filter.id)
      .subscribe(
        (data: any) => {
          this.generalSrv.sweetAlertSucess(data.message);
          this.getAllFilters();
        },
        err => {
          let errMsg = "sorry error occurred try again";
          errMsg = err.error && err.error.message ? err.error.message : errMsg;
          this.generalSrv.sweetAlertError(errMsg);
        }
      )
      .add(
        () =>
          (this.getAllFilters())
      );
  }

  //<!-- FILTER SECTION START --->

  //FETCH SUPERVISOR USERS
  onFetchSupervisorAttachedUsers() {
    this.fetchUsersBySupervisor();
  }

  /**
  * Fetch users attached to a supervisor
  */
  private fetchUsersBySupervisor() {
    const getSurbodinates = this.signupSrv.fetchTaskSubordinates(this.user.email).pipe(map(subs => {
      const res = subs.filter((person) => person.salesPerson == "true");
      const result = res.concat(this.user);
      return result.map(sub => ({
        id: `${sub.id}`,
        salesPerson: `${sub.salesPerson}`,
        fullName: `${sub.firstName} ${sub.lastName}`
      }))
    }));
    forkJoin([getSurbodinates]).subscribe(responses => {
      this.supervisorAttachedUsers = responses[0];
    });
  }

  //WHATSAPP INTEGRATION
  /**
  * WhatsApp Integration
  */
  integrateWhatsappBot() {
    this.isLoading = true;
    this.generalTaskSrv.integrateWhatsappBot(this.whatsAppForm.getRawValue()).subscribe(() => {
      this.isLoading = false;
    }, () => {
    })
  }

  whatsApp() {
    this.isLoading = true;
    this.generalTaskSrv.integrateWhatsapp(this.whatsAppForm.getRawValue()).subscribe(() => {
      this.isLoading = false;
      this.integrateWhatsappBot();
      this.whatsAppForm.reset();
      $("#closeWhatsapp").click();
      this.generalSrv.sweetAlertSucess('Please Check Your WhatsApp');
    }, (error) => {
      this.isLoading = false;
      $("#closeWhatsapp").click();
      this.generalSrv.sweetAlertSucess(error.error.text);
    })
  }

  //INITIALIZING DATA
  /**
  * Internet Loading
  * @param data
    */
  initializeLoad(data) {
    if (data === null || data === undefined) {
      const setError = {
        title: "We couldn't load the data.",
        subTitle: "Kindly Check your Internet & Click Reload to try again.",
        action: "Reload",
        success: false
      };
      this.loader.dataless = setError;
      this.loader.spinnerType = "dataless";
    } else {
      this.allGeneralTasks = data.slice(0, 500);
      this.loader.showSpinner = false;
    }
  }

  /**
  * Internet Loading
  * @param data
  */
  initializeLoad2(data) {
    if (data === null || data === undefined) {
      const setError = {
        title: "We couldn't load the data.",
        subTitle: "Kindly Check your Internet & Click Reload to try again.",
        action: "Reload",
        success: false
      };
      this.loader.dataless = setError;
      this.loader.spinnerType = "dataless";
    } else {
      this.createdTask = data.slice(0, 500);
      this.loader.showSpinner = false;
    }
  }

  filteredDeal(event) {
    alert(event.target.value)
  }

  // Reload Spinner
  async reloadSpinner() {
    this.loader.spinnerType = this.loader.default;
    this.FetchAssignedTasks();
  }

  // Allow user to add a lead when there is none.
  async onActionState() {
    if (this.loader.dataless.success === true) $("#ModalCenter4").show();
    else this.FetchAssignedTasks();
    this.fetchUsersBySupervisor();
  }

  /**
   * Toggling BUTTON FOR FILTER
   * @param type
   */
  toggleSidebar(type) {
    this.mainStyle = type === "open" ? this.halfList : this.fullList;
    this.sidebarState = type === "open" ? "open" : "close";
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

}

